import { Typography, Box, SxProps, Stack } from '@mui/material';
import { ReviewInvitationsCandidateItem } from 'modules/sourcing-shared/shared-steps';
import {
  SourcingSharedCustomizeMessageEmailFormData,
  SourcingSharedCustomizeMessageSmsFormData
} from 'modules/sourcing-shared/forms';

const containerSx: SxProps = {
  direction: 'row'
};

const subjectSx: SxProps = {
  mb: 1
};

const emailBodySx: SxProps = {
  whiteSpace: 'pre-wrap',
  mb: 2
};

type SourcingSharedPreviewInvitationProps = {
  candidate: ReviewInvitationsCandidateItem;
  customizeMessageFormData:
    | SourcingSharedCustomizeMessageEmailFormData
    | SourcingSharedCustomizeMessageSmsFormData;
  filledMessage: string;
  filledSubject: string | undefined;
};

export const SourcingSharedPreviewInvitation: React.FC<
  SourcingSharedPreviewInvitationProps
> = ({ candidate, customizeMessageFormData, filledMessage, filledSubject }) => {
  if (!customizeMessageFormData) {
    return (
      <Box>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Invitation Preview for {candidate.fullName}
        </Typography>
        <Typography color="text.secondary">
          No template available found.
        </Typography>
      </Box>
    );
  }

  return (
    <Stack sx={containerSx}>
      {/* Subject Line */}
      {filledSubject && (
        <Typography variant="subTitle" sx={subjectSx}>
          Subject: {filledSubject}
        </Typography>
      )}

      {/* Email Content */}
      <Typography sx={emailBodySx}>{filledMessage}</Typography>
    </Stack>
  );
};
